import { gql } from "@apollo/client";

export default gql`
  mutation allowVaccinatedWorker($data: AllowVaccinationInput!) {
    allowVaccinatedWorker(data: $data) {
      id
    }
  }
`;
